import { ImageStoreDTO } from 'business/models/Models';
import RMTable from 'components/customComponents/Controls/RMTable';
import React from 'react';
import { storageHeaderColumns } from '../utils';

interface Props {
  imageStoreList: ImageStoreDTO[];
  tableClass?: string;
  headerColumns?: any;
  rowsData?: any;
  selectedIds?: number[];
  enableMultiSelection?: boolean;
  onCheckboxSelectionChange?: (rowIndices: number[]) => void;
  handleOnRowCLick?: (row) => void;
  mainContainerStyle?: React.CSSProperties;
}

const ImageStoreInfoModal = (props: Props) => {
  const {
    imageStoreList,
    tableClass,
    headerColumns,
    rowsData,
    selectedIds,
    onCheckboxSelectionChange,
    handleOnRowCLick,
    mainContainerStyle,
    enableMultiSelection = false,
  } = props;

  const storageData = imageStoreList.map((store) => {
    return {
      name: store.name,
      directory: store.basePath,
      space: store.availableSize,
    };
  });

  return (
    <div id="imagestoreinfomodal-wrapper" className="flex flex-column w-full">
      <RMTable
        columns={headerColumns ? headerColumns : storageHeaderColumns}
        data={rowsData ? rowsData : storageData}
        tableClass={tableClass ? tableClass : 'w-full mb-5'}
        selectedIds={selectedIds}
        enableMultiSelection={enableMultiSelection}
        onCheckboxSelectionChange={onCheckboxSelectionChange}
        onRowClicked={handleOnRowCLick}
        mainContainerStyle={mainContainerStyle}
      />
    </div>
  );
};

export default ImageStoreInfoModal;
